import { Spinner } from '../../../ui/Spinner';
import React from 'react';

interface Props {
    showSpinner: boolean;
    children?: React.ReactNode;
}

export function SpinnerCanvas({ showSpinner, children }: Props) {
    if (showSpinner) {
        return <Spinner />;
    } else {
        return <div>{children}</div>;
    }
}
